import { DotsInputInt, IDotsInputIntProps } from "dots-ui/dotsInputInt";
import { useMemo } from "react";
import { AvisConstants } from "../../../../data/avisConstants";
import { getValueTooltip } from "../../../../utils";

export function AvisInputInt<T = object>(
  props: Readonly<IDotsInputIntProps<T>>,
) {
  const { title, ...restProps } = props;

  const tooltipValue = useMemo(() => {
    return getValueTooltip(title, props.bag, props.bagField);
  }, [props.bag, props.bagField, title]);

  return (
    <DotsInputInt<T>
      spacing="small"
      title={tooltipValue}
      {...restProps}
      max={AvisConstants.max_int_value}
      onlyPositive={props.onlyPositive ?? true}
    />
  );
}
